import { Injectable } from '@angular/core';
import { IonRouterOutlet } from '@ionic/angular';

@Injectable()
export class RouterOutletService {
  routerOutlet?: IonRouterOutlet;
}
